import { Form, Select } from "antd";
import UserSelectOption from "common/components/userSelect/userSelect";
import { customUserHandleSearch } from "utilities/generalUtility";
import { LabeledField } from "../labeledField/labeledField";

const { Option } = Select;

export const JobHiringManagerField = ({
  users = [],
  disabled,
  isFormItem = true,
  extraLabel = null,
  style = {},
}) => {
  const renderField = () => (
    <Select
      showArrow
      showSearch
      allowClear
      mode="multiple"
      optionFilterProp="label"
      optionLabelProp="title"
      placeholder="Select Job Hiring Manager(s)"
      filterOption={customUserHandleSearch}
      getPopupContainer={(triggerNode) => triggerNode.parentNode}
      disabled={disabled}
      style={style}
    >
      {users.map(({ id, name, email, clients }) => (
        <Option key={id} value={id} title={name}>
          <UserSelectOption userEmail={email} clients={clients}>
            {name}
          </UserSelectOption>
        </Option>
      ))}
    </Select>
  );

  if (isFormItem) {
    return (
      <Form.Item
        label="Job Hiring Manager(s)"
        name="managerId"
        rules={[
          {
            required: true,
            message: "Please select job hiring manager(s)",
          },
        ]}
      >
        {renderField()}
      </Form.Item>
    );
  }

  return (
    <LabeledField label="Job Hiring Manager(s)" required extra={extraLabel}>
      {renderField()}
    </LabeledField>
  );
};
